export default {"src":"/_next/static/media/alert-light.9030d73e.svg","height":100,"width":100};